import React from "react";

import { IgSwitch } from "@intelligems/ig-theme";
import { FormControlLabel, Grid } from "@mui/material";

import type { ConfigurationInputProps } from "../../../../../types/organization";
import { toProperCaseWithSpaces } from "../../../../../utils";

export const BooleanConfigInput = ({
  config,
  onChange,
}: ConfigurationInputProps) => {
  return (
    <Grid
      item
      sx={{
        "& .MuiTypography-root": {
          marginLeft: "10px",
        },
      }}
    >
      <FormControlLabel
        control={
          <IgSwitch
            checked={config.value}
            color="primary"
            onClick={() => {
              onChange(!config.value);
            }}
          />
        }
        label={toProperCaseWithSpaces(config.key)}
      />
    </Grid>
  );
};
